import gql from "graphql-tag";

export const EDIT_NEW_TICKETS = gql`
mutation insert_event_paid_ticket_details($data: [event_paid_ticket_details_insert_input!]!) {
  insert_event_paid_ticket_details(objects: $data) {
    affected_rows
  }
}

`